var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



/*****************
 ** WEBPACK FOOTER
 ** ./~/._enquire.js@2.1.6@enquire.js/src/index.js
 ** module id = 493
 ** module chunks = 0 1
 **/